import { Accordion } from 'components/Elements';
import React from 'react';

export const FAQs = () => {
  return (
    <div className="">
      <div className="mx-3 md:mx-40 p-2 md:p-0 mt-12">
        <div className="flex flex-row items-center md:justify-between mb-4">
          <div className="text-2xl md:text-4xl font-black text-white">FAQs</div>
        </div>
      </div>
      <div className="md:ml-36 md:pr-36">
        <Accordion title="What is Wire24?">
          Wire24 is a financial platform offering seamless money transfers, currency exchange,
          budgeting tools, and payment solutions for individuals and businesses worldwide.
        </Accordion>
        <Accordion title="Is Wire24 available in my country?">
          Wire24 is available in over 180 countries. You can check if your country is supported by
          visiting our website.
        </Accordion>
        <Accordion title="How can I sign up for Wire24?">
          Signing up for Wire24 is easy. Visit our website, download the app, and follow the
          on-screen instructions to create an account.
        </Accordion>
        <Accordion title="What types of accounts does Wire24 offer?">
          Wire24 offers personal and business accounts. Personal accounts are for individuals who
          want to manage their finances, while business accounts are for companies that need
          financial solutions.
        </Accordion>
        <Accordion title="How can I add money to my Wire24 account?">
          You can add money to your Wire24 account using bank transfers, debit/credit cards, or cash
          deposits at our partner locations.
        </Accordion>
        <Accordion title="Can I send money internationally?">
          Yes, you can send money to over 180 countries using Wire24. Our platform supports
          international money transfers at competitive rates.
        </Accordion>
        <Accordion title="Are there fees for using Wire24?">
          Wire24 charges a small fee for certain services, such as currency exchange and
          international money transfers. Please refer to our Fee Schedule for more details.
        </Accordion>
        <Accordion title="How does Wire24's currency exchange work?">
          Wire24 offers competitive exchange rates for over 40 currencies. You can exchange money
          instantly using our platform.
        </Accordion>
        <Accordion title="Can I hold multiple currencies in my Wire24 account?">
          Yes, you can hold multiple currencies in your Wire24 account. Our platform supports
          multi-currency wallets for easy money management.
        </Accordion>
      </div>
    </div>
  );
};
